/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestManagementActionMapping {
    getFixupPrototypeFunction() { return ServiceNowRequestManagementActionMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestManagementActionMapping>): ServiceNowRequestManagementActionMapping {
        let obj = Object.assign(new ServiceNowRequestManagementActionMapping(), model);
        ServiceNowRequestManagementActionMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestManagementActionMapping>): ServiceNowRequestManagementActionMapping {
        if (!model) return null;
        return ServiceNowRequestManagementActionMapping.newInstance(<ServiceNowRequestManagementActionMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestManagementActionMapping) {
        if (!obj) return;

        models.ServiceNowRequestManagementActionMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestManagementActionMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestManagementActionMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Corestack action for Request Management
     */
    action: models.ServiceNowRequestManagementAction;

    /**
     * True if Request Management source is ServiceNow
     */
    source_is_servicenow: boolean;

    /**
     * True if Request Management target is ServiceNow
     */
    target_is_servicenow: boolean;

    /**
     * List of ServiceNow attributes for Request Management Action
     */
    service_now_action_attr: Array<string>;

}
